import {
    getProduct,
    listProducts
} from './queries';
import {
    cloneProduct,
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CloneProduct,
    CreateProduct,
    DeleteProduct,
    GetProduct,
    ListProducts,
    Product,
    UpdateProduct
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

const normalizeRecord = (record: Product) => {
    return Object.assign({}, record);
};


export const fetchRecords = async (query: ListRecordsQuery) => {

    const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                          query: listProducts,
                                                                          variables: {
                                                                              filter: { status: 'Active' },
                                                                              ...query
                                                                          },
                                                                      });

    return {
        items: response.data?.listProducts.items?.map(item => normalizeRecord(item)) || [],
        nextToken: response.data?.listProducts.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                        query: getProduct,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getProduct;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateProduct>>({
                                                                           query: createProduct,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createProduct;
};

export const update = async (id: string, record: Product) => {

    console.debug('IN UPDATE', id);

    delete record.created;
    delete record.updated;
    delete record.createdByUsername;
    delete record.createdByUser;
    delete record.lineItems;

    // Filter out null/undefined values
    const cleanRecord = Object.fromEntries(
        Object.entries(record).filter(([_key, value]) => value !== null && value !== undefined && value !== '')
    );

    const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
                                                                           query: (updateProduct),
                                                                           variables: {input: cleanRecord},
                                                                       });
    return response.data?.updateProduct;
};

export const cloneRecord = async (id: string) => {

    const response = await client.graphql<GraphQLQuery<CloneProduct>>({
                                                                          query: (cloneProduct),
                                                                          variables: {id: id},
                                                                      });
    return response.data?.cloneProduct;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
                                                                           query: (deleteProduct),
                                                                           variables: {input: {id: id}},

                                                                       });
    return response.data?.deleteProduct;
};
